module.exports = "<div class=\"container\">\n  <div class=\"main-top\">\n    <img class=\"main-logo\" src=\"assets/img/smartenit-logo.png\">\n    <h3 class=\"ligth-text\">One account, Different Services</h3>\n  </div>\n  <login-form></login-form>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.html
// module id = ./src/app/pages/login/login.html
// module chunks = main